import { __extends } from "tslib";
import { deserializeAws_restJson1GetUserEndpointsCommand, serializeAws_restJson1GetUserEndpointsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetUserEndpointsCommand = /** @class */ (function (_super) {
    __extends(GetUserEndpointsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetUserEndpointsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetUserEndpointsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetUserEndpointsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetUserEndpointsCommand(input, context);
    };
    GetUserEndpointsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetUserEndpointsCommand(output, context);
    };
    return GetUserEndpointsCommand;
}($Command));
export { GetUserEndpointsCommand };
//# sourceMappingURL=GetUserEndpointsCommand.js.map